let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jNyUd"), load("aQnhg"), load("hlgZa")]).then(() => parcelRequire('lAsab'));